export default __webpack_public_path__ + "static/MobileGreenBG-5ce6d15d87c499e84c7fd31a0e707962.png";